var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.displayValue)}}):_c('span',{staticClass:"subtitle grey--text"},[_vm._v("(none)")])}
var staticRenderFns = []

export { render, staticRenderFns }